import { StatusChipStyle } from '@core/models';
import { StatusChips } from '@core/models/status-chips/status-chips.model';

// the colors are CSS variables from theme.scss (defined in colors.scss); most backgrounds are a color at 50%
const STATUS_CHIP_COLORS_BACKGROUND = {
  success: 'color-mix(in srgb, var(--color-fill4-lt) 50%, transparent)',
  inProgress: 'color-mix(in srgb, var(--color-fill6-lt) 50%, transparent)',
  warn: 'color-mix(in srgb, var(--color-fill5-lt) 50%, transparent)',
  warnYel: 'color-mix(in srgb, var(--color-fill3-vivid) 50%, transparent)',
  neutral: 'var(--color-grey5)',
  none: ''
};

const STATUS_CHIP_COLORS_FOREGROUND = {
  success: 'var(--color-fill4-dk)',
  inProgress: 'var(--color-fill6-dk)',
  warn: 'var(--color-warn)',
  warnYel: 'var(--color-fill3-dk)',
  neutral: 'var(--color-grey1)'
};

const SUCCESS_CHIP_BG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.success,
  color: STATUS_CHIP_COLORS_FOREGROUND.success,
};

const SUCCESS_CHIP_NO_BG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.none,
  color: STATUS_CHIP_COLORS_FOREGROUND.success,
};

const WARN_CHIP_BG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.warn,
  color: STATUS_CHIP_COLORS_FOREGROUND.warn,
};

const WARN_CHIP_YEL_BG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.warnYel,
  color: STATUS_CHIP_COLORS_FOREGROUND.warnYel,
};

const WARN_CHIP_NOBG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.none,
  color: STATUS_CHIP_COLORS_FOREGROUND.warn,
};

const INPROG_CHIP_BG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.inProgress,
  color: STATUS_CHIP_COLORS_FOREGROUND.inProgress,
};

const INPROG_CHIP_NOBG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.none,
  color: STATUS_CHIP_COLORS_FOREGROUND.inProgress,
};

const NEUTRAL_CHIP_BG: StatusChipStyle = {
  backgroundColor: STATUS_CHIP_COLORS_BACKGROUND.neutral,
  color: STATUS_CHIP_COLORS_FOREGROUND.neutral
}

export const STATUS_CHIPS_STYLES: StatusChips = {
  successBg: SUCCESS_CHIP_BG,
  successNoBg: SUCCESS_CHIP_NO_BG,
  warnBg: WARN_CHIP_BG,
  warnYelBg: WARN_CHIP_YEL_BG,
  warnNoBg: WARN_CHIP_NOBG,
  inProgBg: INPROG_CHIP_BG,
  inProgNoBg: INPROG_CHIP_NOBG,
  neutralBg: NEUTRAL_CHIP_BG
};
